<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Gérer les signataires</div>
</div>

@if (contractSignatories.length == 0) {
    <div class="data-container empty-list">
        La liste des signataires est vide.
    </div>
} @else {
    <div class="data-container">
        @for (signatory of contractSignatories; track signatory) {
            <div class="card data-card" [style]="!signatory.isSelected ? 'background: transparent !important;' : ''">
                <div class="card-content-section" (click)="handlePopup('update', signatory)">
                    <div class="data-details">
                        <div class="client-info">
                        <span class="detail-value user">
                            <i class="tim-icons icon-single-02 detail-icon" style="font-family: Nucleo !important;"></i>
                            {{ signatory.lastname + ' ' + signatory.firstname }}
                        </span>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="data-header-line">
                        <div class="data-infos">Email: {{ signatory.email }}</div>
                        <div class="data-infos">Téléphone: {{ signatory.phoneNumber }}</div>
                        <div class="data-infos">Fonction: {{ signatory.role }}</div>
                    </div>
                </div>

                <div class="card-action-section" (click)="handlePopup('delete', signatory)">
                    <div class="action-icon-wrapper">
                        <i class="tim-icons icon-trash-simple" style="font-family: Nucleo !important;"></i>
                    </div>
                    <div class="action-label">Supprimer</div>
                </div>
            </div>
        }
    </div>
}

<div class="row w-100 pt-3 text-center">
    <div class="cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="submit" class="cta_btn level_2 column" (click)="handlePopup('add', null)">Ajouter<span></span></button>
    </div>
</div>

<!---------------------------------------------- POP-UP ------------------------------------------>
@if (action) {
    <div class="container-popup">
        <div id="check-popup-form">
            <span class="close-icon" aria-hidden="true" (click)="handlePopup(null, null)">&times;</span>
            <div class="row w-100 pl-5 pr-4 pb-3 text-center">
                <div class="bold-text blue-color align-content-center w-100 nudge-right">
                    @switch (action) {
                        @case ('add') {
                            Créer un nouveau signataire
                        }
                        @case ('update') {
                            Modifier un signataire
                        }
                        @case ('delete') {
                            Supprimer un signataire
                        }
                    }
                </div>
                <div class="bold-red-text align-content-center w-100 mt-5">
                    @if (form) {
                        <form [formGroup]="form" (submit)="save()">
                            <div class="form-group flex-mfa">
                                <span class="bold-label-text float-left">Signataire principal</span>
                                <select formControlName="isSelected" class="custom-select mt-3">
                                    <option value="false">Non</option>
                                    <option value="true">Oui</option>
                                </select>
                            </div>
                            <div class="form-group flex-mfa">
                                <span class="bold-label-text float-left">Civilité</span>
                                <select formControlName="civility" class="custom-select mt-3">
                                    <option value="Mr">Mr</option>
                                    <option value="Mme">Mme</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <span class="bold-label-text float-left">Nom*:</span>
                                <input type="text" class="form-control" placeholder="Nom" formControlName="lastname">
                                @if (formSubmitted && form.controls.lastname.errors) {
                                    <small class="form-text error-message">{{ getError('lastname') }}</small>
                                }
                            </div>
                            <div class="form-group">
                                <span class="bold-label-text float-left">Prénom*:</span>
                                <input type="text" class="form-control" placeholder="Prénom" formControlName="firstname">
                                @if (formSubmitted && form.controls.firstname.errors) {
                                    <small class="form-text error-message">{{ getError('firstname') }}</small>
                                }
                            </div>
                            <div class="form-group">
                                <span class="bold-label-text float-left">Email*:</span>
                                <input type="text" class="form-control" placeholder="Adresse email" formControlName="email">
                                @if (formSubmitted && form.controls.email.errors) {
                                    <small class="form-text error-message">{{ getError('email') }}</small>
                                }
                            </div>
                            <div class="form-group">
                                <span class="bold-label-text float-left">N° téléphone:*</span>
                                <input id="phone-number" type="text" class="form-control" placeholder="Téléphone" formControlName="phoneNumber">
                                @if (formSubmitted && form.controls.phoneNumber.errors) {
                                    <small class="form-text error-message">{{ getError('phoneNumber') }}</small>
                                }
                            </div>
                            <div class="form-group">
                                <span class="bold-label-text float-left">Fonction:*</span>
                                <input id="role" type="text" class="form-control" placeholder="Fonction" formControlName="role">
                                @if (formSubmitted && form.controls.role.errors) {
                                    <small class="form-text error-message">{{ getError('role') }}</small>
                                }
                            </div>
                            <div class="row w-100 pt-3 text-center">
                                <div class="cta_container">
                                    <button type="button" class="cta_cancel column" (click)="handlePopup(null, null)">Annuler<span></span></button>
                                    <button type="submit" class="cta_btn level_2 column">Enregistrer</button>
                                </div>
                            </div>
                        </form>
                    } @else {
                        <div class="bold-red-text mb-5">Êtes-vous sûr de vouloir supprimer ce signataire ?</div>
                        <div class="row w-100 pt-3 text-center">
                            <div class="cta_container">
                                <button type="button" class="cta_cancel column" (click)="handlePopup(null, null)">Annuler<span></span></button>
                                <button type="button" class="cta_btn level_2 column" (click)="delete()">Supprimer</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}